import AnimatedLayout from 'components/layouts/animated-layout';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';
import { SecurityKey } from 'features/profile';

const ApiTokenTab = () => {
    return (
        <AnimatedLayout>
            <HelmetTabComponent title="توکن وب سرویس" />

            <SettingsContentHeader
                title="توکن وب سرویس"
                description="توکن دسترسی وب‌سرویس خود را مشاهده، کپی یا بروزرسانی کنید."
            />

            <SecurityKey />
        </AnimatedLayout>
    );
};

export default ApiTokenTab;
